import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";
import axios from 'axios';
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import Loading from 'react-fullscreen-loading';
import { toast } from "react-hot-toast";
import Select from "react-select";
import useCountryList from "react-select-country-list";

export default function EditUserProfiles() {
  const navigate = useNavigate();
  const [screenloader, setScreenloader] = useState(true);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [country, setCountry] = useState("");
  const [preferredPaymentMethod, setPreferredPaymentMethod] = useState("");
  const [preferredPaymentTerm, setPreferredPaymentTerm] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [designation, setDesignation] = useState("");
  const [organization, setOrganization] = useState("");
  const Param1 = useParams();
  const id = Param1.id;
  const [type, setType] = useState("");
  const [profileType, setProfileType] = useState({});

  const countries = useCountryList();
  const countryOptions = countries.getData();

  useEffect(() => {
    getUserProfiles();
  }, []);

  const getUserProfiles = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/admin/user_profiles/${id}`, {
      headers: {
        'Access-Token': localStorage.getItem('accessToken'),
      }
    })
      .then(res => {
        setScreenloader(false);
        if (res.data.status) {
          const UserProfilesData = res.data.user_profiles;
          setEmail(UserProfilesData.email || "")
          setName(UserProfilesData.name || "");
          setPhone(UserProfilesData.phone || "");
          setDesignation(UserProfilesData.designation || "");
          setOrganization(UserProfilesData.organization || "");
          setAddressLine1(UserProfilesData.address_line_1 || "");
          setAddressLine2(UserProfilesData.address_line_2 || "");
          setCountry({label: UserProfilesData.country }|| {});
          setPreferredPaymentMethod(UserProfilesData.preferred_payment_method || "");
          setPreferredPaymentTerm(UserProfilesData.preferred_payment_term || "");
          setProfileType({value: UserProfilesData?.type , label: UserProfilesData?.type});
        } else {
          toast.error('Something Went Wrong');
          return;
        }
      })
      .catch(er => {
        setScreenloader(false);
        toast.error(er.response?.data?.message || "Something Went Wrong");
      });
  };

  const EditUserProfiles = async () => {
    await axios.put(`${process.env.REACT_APP_API_URL}/admin/user_profiles/${id}`, {
      email,
      phone,
      name,
      designation,
      organization,
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      country: country.label,
      preferred_payment_method: preferredPaymentMethod,
      preferred_payment_term: preferredPaymentTerm,
      type: profileType?.value,
    }, {
      headers: {
        'Access-Token': localStorage.getItem('accessToken'),
      }
    })
      .then(res => {
        if (res.data.status) {
          toast.success('User Profiles has been updated');
          setTimeout(()=>{
            window.location.reload();
          },500)
         navigate('/admin/UserProfiles');
        } else {
          setScreenloader(false);
          toast.error('Something Went Wrong');
        }
      })
      .catch(er => {
        setScreenloader(false);
        toast.error(er.response?.data?.message || "Something Went Wrong");
      });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setScreenloader(true);
    await EditUserProfiles();
  };

  const profileTypeOptions = [
    { value: "Reseller", label: "Reseller" },
    { value: "User", label: "User" },
  ];

  const handleProfileTypeChange = (selectedOption) => {
    setProfileType(selectedOption);
  };

  return (
    <div>
      <AdminDashboardLayout />
      <Loading loading={screenloader} background="#fff" loaderColor="#883484" />
      <div className='content-page-bg'>
        <div className='content-page'>
          <div className='content'>
            <h3>Edit User Profiles</h3>
            <Container fluid className="behind">
              <Card className="mt-4">
                <Card.Body>
                  <form onSubmit={handleFormSubmit}>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="name"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Enter name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="email"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Enter email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="phone"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Phone
                        </label>
                        <input
                          type="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Enter phone"
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="designation"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="designation"
                          placeholder="Enter designation"
                          value={designation}
                          onChange={(e) => setDesignation(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="organization"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="organization"
                          placeholder="Enter organization"
                          value={organization}
                          onChange={(e) => setOrganization(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="addressLine1"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="addressLine1"
                          placeholder="Enter address line 1"
                          value={addressLine1}
                          onChange={(e) => setAddressLine1(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="addressLine2"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="addressLine2"
                          placeholder="Enter address line 2"
                          value={addressLine2}
                          onChange={(e) => setAddressLine2(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12">
                        <label
                          htmlFor="country"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Country
                        </label>
                        <Select
                          options={countryOptions}
                          value={country}
                          onChange={setCountry}
                          placeholder="Select Country"
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="row my-4">
                    <div className="col-lg-6 col-md-6 col-12 ">
                        <label
                          htmlFor="preferredPaymentMethod"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Preferred Payment Method
                        </label>
                        <select
                          className="form-control"
                          id="preferredPaymentMethod"
                          value={preferredPaymentMethod}
                          onChange={(e) =>
                            setPreferredPaymentMethod(e.target.value)
                          }
                        >
                          <option value="Cash">Cash</option>
                          <option value="Card">Card</option>
                          <option value="Bank Transfer">Bank Transfer</option>
                        </select>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="preferredPaymentTerm"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Preferred Payment Term
                        </label>
                        <select
                          className="form-control"
                          id="preferredPaymentTerm"
                          value={preferredPaymentTerm}
                          onChange={(e) =>
                            setPreferredPaymentTerm(e.target.value)
                          }
                        >
                          <option value="Advance">Advance</option>
                          <option value="NET 7">Net 7</option>
                          <option value="NET 15">Net 15</option>
                          <option value="NET 30">Net 30</option>
                        </select>
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6 col-md-6 col-12 mt-md-0 mt-4">
                        <label
                          htmlFor="profileType"
                          className="form-label"
                          style={{ fontWeight: "bold", fontSize: "14px" }}
                        >
                          Profile Type
                        </label>
                        <Select
                            options={profileTypeOptions}
                            value={profileType}
                            onChange={handleProfileTypeChange}
                            placeholder="Select Profile Type"
                            isClearable
                          />
                      </div>
                    </div>
                    
                    <div className='d-flex flex-column flex-sm-row gap-2 mb-3'>
                      <Button className="btn admin-btn" type="submit">
                        Update User Profile
                      </Button>
                      <Button style={{ backgroundColor: '#5f75a5ff', color: '#d8d6d6ff', border: 'none'}} onClick={()=>{navigate(-1)}} variant="danger">Back</Button>
                    </div>
                  </form>
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}
